import '../../css/adminStyling.css';

const AdminInfo = () => {
    return (
        <>

            <div className="adminInfoContainer">
                <h3>Admin gedeelte van de Brinkruiters leden app</h3>
                <p>Op deze pagina vind je een kort overzicht over waar elk van de admin onderdelen voor gebruikt kan worden.</p>
                <br />
                <hr />
                <br />
                <h3>Activiteiten:</h3>
                <ul>
                    <li>Overzicht van alle aankomende activiteiten</li>
                    <li>Het aanmaken van een nieuwe activiteit</li>
                    <li>Het verwijderen van een activiteit</li>
                    <li>Het wijzigen van een activiteit (activiteit naam, omschrijving en datum)</li>
                    <li>Het toevoegen van een nieuwe taak aan een activiteit</li>
                    <li>Het verwijderen van een taak van een activiteit</li>
                    <li>Het wijzigen van een al eerder toegevoegde taak van een activiteit (taak naam, omschrijving, dagdeel, contactpersoon)</li>
                </ul>
                <br />
                <hr />
                <br />
                <h3>Aanmeldingen</h3>
                <ul>
                    <li>Overzicht van taken zonder aanmelding</li>
                    <li>Overzicht van taken met nog niet bevestigde aanmelding</li>
                    <li>Overzicht van taken met bevestigde aanmeldingen</li>
                    <li>Handmatig toevoegen van een vrijwilliger aan een taak </li>
                    <li>Aanmeldingen bevestigen</li>
                    <li>Aanmeldingen verwijderen</li>
                    <li>Bevestiging verwijderen</li>
                    <li>Contact opnemen met vrijwilliger</li>
                </ul>
                <br />
                <hr />
                <br />
                <h3>Gebruikers</h3>
                <ul>
                    <li>Overzicht van alle gebruikers (accounts) van deze app</li>
                    <li>Verwijderen van een gebruiker</li>
                    <li>Wijzigen van gebruiker gegevens (naam, gebruikersnaam, loginemail)</li>
                    <li>Resetten van het wachtwoord van een gebruiker</li>
                    <li>Contact opnemen met een gebruiker (via email)</li>
                </ul>
                <br />
                <hr />
                <br />
                <h3>Instellingen</h3>
                <ul>
                    <li>Toevoegen/verwijderen van toegang tot de admin gedeeltes door gebruikers</li>
                </ul>

            </div>
        </>
    );
}

export default AdminInfo;